import Breadcrumbs from 'components/Breadcrumbs';
import * as React from 'react';
import { Typography } from 'ui-kit';

export const Common = props => (
  <div className="px-6 py-9">
    <Breadcrumbs />
    <Typography title="Common" variant="subheader" />
  </div>
);
